import { RootState, store } from '../reducers';

export { store } from '../reducers';

/**
 * This is a helper method to set up a listener to the redux store.
 * You pass in a selector function which is used to get the item of the store you care about.
 * The observer will then pay attention to this item and see when it's been changed (by reference for
 * objects and by value for primitives).
 * When there is a change, it will execute the callback and pass it the updated value.
 *
 * You can use this to easily watch for changes in the store outside of react components (which should
 * never need this method since the components can connect to the store via react-redux's connect)
 *
 * @param {func} select Selector function
 * @param {func} onChange Callback to execute when there is a change
 */
export const observeStore = <T>(
  select: (state: RootState) => T,
  onChange: (value: T) => void,
) => {
  let currentState: T;

  const handleChange = () => {
    const nextState = select(store.getState());

    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState);
    }
  };

  const unsubscribe = store.subscribe(handleChange);

  handleChange();
  return unsubscribe;
};
